const BACKEND_API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';

const buildQuery = (params) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, value);
    }
  });
  return searchParams.toString();
};

export const fetchOpenTickets = async ({ key, eventDateAfter, eventDateBefore }) => {
  const query = buildQuery({ key, eventDateAfter, eventDateBefore });
  const response = await fetch(`${BACKEND_API_URL}/api/kpcard/tickets/open?${query}`);

  if (!response.ok) {
    let message = 'Failed to fetch open tickets';
    try {
      const errorBody = await response.json();
      message = errorBody.message || message;
    } catch (e) {
      // Keep default error message when response is not JSON.
    }
    throw new Error(message);
  }

  return response.json();
};

export const closeOpenTicket = async (eventId, payload = {}) => {
  const response = await fetch(`${BACKEND_API_URL}/api/kpcard/tickets/${eventId}/close`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    let message = 'Failed to close ticket';
    try {
      const errorBody = await response.json();
      message = errorBody.message || message;
    } catch (e) {
      // Keep default error message when response is not JSON.
    }
    throw new Error(message);
  }

  return response.json();
};
